export enum TypesMarks {
  SHIP = "ship",
  PLANE = "plane",
  TRAIN = "train",
  OUT_OF_STOCK = "outOfStock",
}

export enum TypesColors {
  AVAILABLE = "#80C67A",
  PO = "#5295E0",
  SO = "#F19867",
  OUT_OF_STOCK = "#FE5858",
}

export const typesMarksMap = {
  [TypesMarks.SHIP]: {
    icon: "🚢",
  },
  [TypesMarks.PLANE]: {
    icon: "✈️",
  },
  [TypesMarks.TRAIN]: {
    icon: "🚂",
  },
  [TypesMarks.OUT_OF_STOCK]: {
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M7.81243 0.506901C7.87686 0.332777 8.12314 0.332777 8.18757 0.506901L10.1288 5.75303C10.1491 5.80777 10.1922 5.85093 10.247 5.87119L15.4931 7.81243C15.6672 7.87686 15.6672 8.12314 15.4931 8.18757L10.247 10.1288C10.1922 10.1491 10.1491 10.1922 10.1288 10.247L8.18757 15.4931C8.12314 15.6672 7.87686 15.6672 7.81243 15.4931L5.87119 10.247C5.85093 10.1922 5.80777 10.1491 5.75303 10.1288L0.506901 8.18757C0.332777 8.12314 0.332777 7.87686 0.506901 7.81243L5.75303 5.87119C5.80777 5.85093 5.85093 5.80777 5.87119 5.75303L7.81243 0.506901Z" fill="#FE5858"/></svg>`,
  },
};

export const deliveryData = [
  {
    id: "B0D15LQ983",
    keys: [
      {
        key: 1,
        type: "PO",
        periods: {
          pasted: [
            {
              start: "2024-01-01",
              end: "2024-02-05",
            },
            {
              start: "2024-06-08",
              end: "2024-06-24",
            },
          ],
          predict: [
            {
              start: "2024-09-08",
              end: "2024-09-20",
            },
          ],
        },
      },
      {
        key: 2,
        type: "SO",
        periods: {
          pasted: [
            {
              start: "2024-02-03",
              end: "2024-03-12",
              type: TypesMarks.SHIP,
            },
            {
              start: "2024-06-25",
              end: "2024-07-05",
              type: TypesMarks.PLANE,
            },
          ],
          predict: [
            {
              start: "2024-09-21",
              end: "2024-10-22",
              type: TypesMarks.TRAIN,
            },
          ],
        },
      },
      {
        key: 3,
        type: "Available",
        periods: {
          pasted: [
            {
              start: "2024-03-13",
              end: "2024-04-25",
            },
            {
              start: "2024-07-06",
              end: "2024-07-29",
            },
          ],
          predict: [
            {
              start: "2024-10-23",
              end: "2024-11-02",
            },
          ],
        },
      },
    ],
  },
];

export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const types = [
  {
    label: "Available",
    color: "#80C67A",
    icon: null,
  },
  {
    label: "PO",
    color: "#5295E0",
    icon: null,
  },
  {
    label: "SO",
    color: "#F19867",
    icon: null,
  },
  {
    label: "Potential out-of-stock risk",
    color: "transparent",
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M7.81243 0.506901C7.87686 0.332777 8.12314 0.332777 8.18757 0.506901L10.1288 5.75303C10.1491 5.80777 10.1922 5.85093 10.247 5.87119L15.4931 7.81243C15.6672 7.87686 15.6672 8.12314 15.4931 8.18757L10.247 10.1288C10.1922 10.1491 10.1491 10.1922 10.1288 10.247L8.18757 15.4931C8.12314 15.6672 7.87686 15.6672 7.81243 15.4931L5.87119 10.247C5.85093 10.1922 5.80777 10.1491 5.75303 10.1288L0.506901 8.18757C0.332777 8.12314 0.332777 7.87686 0.506901 7.81243L5.75303 5.87119C5.80777 5.85093 5.85093 5.80777 5.87119 5.75303L7.81243 0.506901Z" fill="#FE5858"/></svg>`,
  },
];
